export default (state, action) => {
    var newState = {...state};

    switch (action.type) {
        case 'INCREMENT_ACTIVE_SAVES':
            var count = newState.activeSavesCount || 0;
            newState.activeSavesCount = count + 1;
            break;
        case 'DECREMENT_ACTIVE_SAVES':
            var count = newState.activeSavesCount || 1;
            newState.activeSavesCount = count - 1;
            newState.failedSavesCount = 0;
            break;
        case 'INCREMENT_FAILED_SAVES':
            var failedCount = newState.failedSavesCount || 0;
            newState.failedSavesCount = failedCount + 1;
            var activeCount = newState.activeSavesCount -= 1;
            if (activeCount < 0) activeCount = 0;
            newState.activeSavesCount = activeCount;
            break;
        default:
            newState = state || {};
            break;
    }

    return newState;
}